import { render } from "./SideBarMenuItem.vue?vue&type=template&id=fb9d49a4"
import script from "./SideBarMenuItem.vue?vue&type=script&lang=js"
export * from "./SideBarMenuItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__